import { Children, Component } from 'react';
import styled from 'styled-components';
import { BaseLayout } from '../Layout/BaseLayout';
import { IBaseLayoutProps } from '../Layout/IBaseLayoutProps';

const LayoutElement = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-start;
  flex-flow: column nowrap;
  overflow: auto;
` as any;

export type SingleRowLayoutAlignment = 'left' | 'center';

type IProps = IBaseLayoutProps;

export class SingleRowLayout extends Component<IProps> {
  public render() {
    return (
      <BaseLayout {...this.props} data-testid="SingleRowLayout">
        <LayoutElement>{Children.only(this.props.children)}</LayoutElement>
      </BaseLayout>
    );
  }
}
